import { render } from "./ProfileTrendsBaselineNorms.vue?vue&type=template&id=6829fe82"
import script from "./ProfileTrendsBaselineNorms.vue?vue&type=script&lang=js"
export * from "./ProfileTrendsBaselineNorms.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__